export const BASE_PAGE_TITLE = 'Myra AI'
